import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { BottomNavbarComponent, NavItem } from '../../shared/mob-bottom-nav/mob-bottom-nav.component';

@Component({
    selector: 'app-chc',
    standalone: true,
    imports: [RouterOutlet, BottomNavbarComponent],
    template: `
        <router-outlet></router-outlet>
        <app-bottom-navbar [navItems]="navItems"></app-bottom-navbar>
    `
})
export class CHCComponent implements OnInit, OnDestroy {
    navItems: NavItem[] = [
        {
            label: 'Home',
            svg: 'home-active',
            inActiveSvg: 'home',
            route: '/mobile/chc/home',
            exact: true
        },
        {
            label: 'Profile',
            svg: 'profile-active',
            inActiveSvg: 'profilee',
            route: '/mobile/chc/profile'
        },
        {
            label: 'Activity',
            svg: 'activity-active',
            inActiveSvg: 'activity',
            route: '/mobile/chc/activity'
        },
        {
            label: 'Finance',
            svg: 'finance-active',
            inActiveSvg: 'finance',
            route: '/mobile/chc/finance'
        }
    ];

    private scrollSub!: Subscription;

    constructor(
        private router: Router,
        @Inject(DOCUMENT) private document: Document
    ) {}

    ngOnInit(): void {
        this.scrollSub = this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => {
            const scrollContainer = this.document.querySelector('mat-sidenav-content');
            if (scrollContainer) {
                scrollContainer.scrollTop = 0;
            }
        });
    }

    ngOnDestroy(): void {
        this.scrollSub?.unsubscribe();
    }
}
